import { useNavigate } from "react-router-dom";
import React, { useContext, useState } from "react";
import temporaryAvatar from "../../assets/sampleAvatar.png";
import { CurrentUserContext } from "../../App";

export default function Navbar() {
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  function handleItemClick(item) {
    setSelectedItem(item);
  }

  function handleLogout() {
    setShowLogoutConfirm(true);
  }

  function confirmLogout() {
    localStorage.removeItem("currentUser");
    setCurrentUser(null);
    navigate("/login");
  }

  return (
    <>
      <nav
        id="navbar"
        className="navbar flex-column justify-content-evenly align-items-center position-fixed"
        style={{
          width: "7.5rem",
          height: "50rem",
          marginLeft: "1.3rem",
          backgroundColor: "var(--nav-gray)",
        }}
      >
        {/* Memories */}
        <div
          title="Memories"
          style={{ cursor: "pointer" }}
          onClick={() => { navigate("/memories"); handleItemClick("memories"); }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g opacity={selectedItem === "memories" ? "1" : "0.75"}>
              <path d="M0.668463 7.95046C-0.619985 4.36111 5.0862 2.61246 6.00646 6.01774L6.74282 7.4903L8.3074 3.90095C9.6327 1.98663 11.682 2.79654 12.541 3.44078C14.9707 2.77813 16.069 4.33044 16.3144 5.18943L17.787 5.6496C18.3023 3.80892 19.2595 2.78733 20.2719 2.88857C23.217 3.18308 23.6465 5.0974 23.4931 6.01774L18.2471 18.2583C16.7009 20.5408 15.0873 21.1727 14.4737 21.2034C13.6638 21.4979 11.8661 21.4489 11.0684 21.3875C9.50385 20.7126 6.24583 19.3075 5.73044 19.0866C5.21505 18.8658 4.77942 18.0129 4.62603 17.6141L0.668463 7.95046Z"
                stroke={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"} strokeWidth="0.552207" strokeLinejoin="round" />
              <path d="M3.0614 6.47821C2.39876 6.6991 2.60123 7.36788 2.7853 7.67466C3.61362 9.88349 5.43593 14.7061 6.09858 16.3259C6.92689 18.3507 7.66317 17.5223 11.0684 19.0869C13.7927 20.3386 16.1917 17.8905 17.0507 16.51L18.2471 14.025L21.6524 5.55787C21.6217 5.3738 21.4315 4.95044 20.9161 4.72956C20.4007 4.50868 20.0878 4.94431 19.9958 5.18973C18.8607 7.82806 16.5537 13.2151 16.4064 13.6569C16.2224 14.2091 15.6702 14.3011 15.21 14.5772C14.7498 14.8534 12.8171 14.3932 12.7251 13.841C12.633 13.2888 11.6206 13.1047 11.0684 13.3808C10.5162 13.6569 9.13572 11.6321 9.41182 12.4605C9.6327 13.1231 9.19707 14.2705 8.95165 14.7613C8.36876 14.884 7.29503 15.019 7.66317 14.5772C8.12334 14.025 7.66317 13.3808 7.66317 12.7366C7.66317 12.2212 6.62011 11.6015 6.09858 11.356L4.16586 7.12245C4.07381 6.81567 3.72405 6.25733 3.0614 6.47821Z"
                fill={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"}
                stroke={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"} strokeWidth="0.552207" strokeLinejoin="round" />
              <line x1="10.5164" y1="5.56286" x2="8.77273" y2="10.0674"
                stroke={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"} strokeWidth="1.28848" strokeLinecap="round" />
              <line x1="16.4066" y1="7.58727" x2="14.6629" y2="12.0918"
                stroke={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"} strokeWidth="1.28848" strokeLinecap="round" />
              <path d="M13.8779 5.51367L11.6691 11.2198"
                stroke={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"} strokeWidth="1.28848" strokeLinecap="round"
                fill={selectedItem === "memories" ? "var(--main-purple)" : "var(--main-white)"} />
            </g>
          </svg>
        </div>

        {/* Search */}
        <ion-icon
          title="Search"
          name="search-outline"
          onClick={() => { navigate("/search"); handleItemClick("search"); }}
          style={{
            color: selectedItem === "search" ? "var(--main-purple)" : "var(--main-white)",
            opacity: selectedItem === "search" ? "1" : "0.75",
            cursor: "pointer",
          }}
        ></ion-icon>

        {/* Connect */}
        <div
          title="Connect"
          style={{ cursor: "pointer" }}
          onClick={() => { navigate("/connect"); handleItemClick("connect"); }}
        >
          <svg width="24" height="24" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 12.5592H12V12.0053C12 11.2667 11.6333 10.6709 10.9 10.2176C10.1667 9.76443 9.2 9.53783 8 9.53783C6.8 9.53783 5.83333 9.76443 5.1 10.2176C4.36667 10.6709 4 11.2667 4 12.0053V12.5592ZM8 8.53069C8.55 8.53069 9.02083 8.33346 9.4125 7.939C9.80417 7.54454 10 7.07035 10 6.51643C10 5.96251 9.80417 5.48831 9.4125 5.09385C9.02083 4.69939 8.55 4.50216 8 4.50216C7.45 4.50216 6.97917 4.69939 6.5875 5.09385C6.19583 5.48831 6 5.96251 6 6.51643C6 7.07035 6.19583 7.54454 6.5875 7.939C6.97917 8.33346 7.45 8.53069 8 8.53069ZM2 16.5878C1.45 16.5878 0.979167 16.3905 0.5875 15.9961C0.195833 15.6016 0 15.1274 0 14.5735V2.4879C0 1.93398 0.195833 1.45978 0.5875 1.06532C0.979167 0.670863 1.45 0.473633 2 0.473633H14C14.55 0.473633 15.0208 0.670863 15.4125 1.06532C15.8042 1.45978 16 1.93398 16 2.4879V7.02L20 2.99146V14.0699L16 10.0414V14.5735C16 15.1274 15.8042 15.6016 15.4125 15.9961C15.0208 16.3905 14.55 16.5878 14 16.5878H2ZM2 14.5735H14V2.4879H2V14.5735Z"
              fill={selectedItem === "connect" ? "var(--main-purple)" : "var(--main-white)"}
              opacity={selectedItem === "connect" ? "1" : "0.5"} />
          </svg>
        </div>

        {/* Chats */}
        <div
          title="Chat"
          style={{ cursor: "pointer" }}
          onClick={() => { navigate("/chat"); handleItemClick("chat"); }}
        >
          <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12.0944H11C11.2833 12.0944 11.5208 11.9979 11.7125 11.8048C11.9042 11.6118 12 11.3726 12 11.0872C12 10.8019 11.9042 10.5627 11.7125 10.3697C11.5208 10.1766 11.2833 10.0801 11 10.0801H5C4.71667 10.0801 4.47917 10.1766 4.2875 10.3697C4.09583 10.5627 4 10.8019 4 11.0872C4 11.3726 4.09583 11.6118 4.2875 11.8048C4.47917 11.9979 4.71667 12.0944 5 12.0944ZM5 9.07298H15C15.2833 9.07298 15.5208 8.97647 15.7125 8.78343C15.9042 8.5904 16 8.3512 16 8.06585C16 7.7805 15.9042 7.5413 15.7125 7.34827C15.5208 7.15523 15.2833 7.05872 15 7.05872H5C4.71667 7.05872 4.47917 7.15523 4.2875 7.34827C4.09583 7.5413 4 7.7805 4 8.06585C4 8.3512 4.09583 8.5904 4.2875 8.78343C4.47917 8.97647 4.71667 9.07298 5 9.07298ZM5 6.05159H15C15.2833 6.05159 15.5208 5.95507 15.7125 5.76203C15.9042 5.569 16 5.32981 16 5.04445C16 4.7591 15.9042 4.5199 15.7125 4.32687C15.5208 4.13384 15.2833 4.03732 15 4.03732H5C4.71667 4.03732 4.47917 4.13384 4.2875 4.32687C4.09583 4.5199 4 4.7591 4 5.04445C4 5.32981 4.09583 5.569 4.2875 5.76203C4.47917 5.95507 4.71667 6.05159 5 6.05159ZM4 16.1229L1.7 18.4393C1.38333 18.7582 1.02083 18.8296 0.6125 18.6533C0.204167 18.4771 0 18.1624 0 17.7091V2.02305C0 1.46913 0.195833 0.99494 0.5875 0.60048C0.979167 0.206019 1.45 0.00878906 2 0.00878906H18C18.55 0.00878906 19.0208 0.206019 19.4125 0.60048C19.8042 0.99494 20 1.46913 20 2.02305V14.1086C20 14.6626 19.8042 15.1368 19.4125 15.5312C19.0208 15.9257 18.55 16.1229 18 16.1229H4ZM3.15 14.1086H18V2.02305H2V15.2417L3.15 14.1086Z"
              fill={selectedItem === "chat" ? "var(--main-purple)" : "var(--main-white)"}
              opacity={selectedItem === "chat" ? "1" : "0.5"} />
          </svg>
        </div>

        {/* Profile */}
        <div
          title="Profile"
          className="d-flex justify-content-center align-items-center"
          onClick={() => { navigate("/profile"); handleItemClick("profile"); }}
          style={{
            width: "2.4rem",
            height: "2.4rem",
            cursor: "pointer",
            border: selectedItem === "profile" ? "2px solid var(--main-purple)" : "none",
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <img
            src={currentUser?.avatar && currentUser.avatar !== "sampleAvatar.png" ? currentUser.avatar : temporaryAvatar}
            alt="Profile Avatar"
            className="w-100 h-100 rounded-circle"
            style={{ objectFit: "cover" }}
          />
        </div>

        {/* Notifications */}
        <div
          title="Notifications"
          style={{ cursor: "pointer" }}
          onClick={() => { navigate("/notifications"); handleItemClick("notifications"); }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_666_4045" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="var(--main-white)" />
            </mask>
            <g mask="url(#mask0_666_4045)">
              <path d="M2.00009 12C2.00009 10.6167 2.26259 9.31667 2.78759 8.1C3.31259 6.88333 4.02509 5.825 4.92509 4.925C5.82509 4.025 6.88343 3.3125 8.10009 2.7875C9.31676 2.2625 10.6168 2 12.0001 2C12.4501 2 12.8918 2.02917 13.3251 2.0875C13.7584 2.14583 14.1834 2.23333 14.6001 2.35C14.3334 2.6 14.0959 2.875 13.8876 3.175C13.6793 3.475 13.5084 3.79167 13.3751 4.125C13.1418 4.09167 12.9126 4.0625 12.6876 4.0375C12.4626 4.0125 12.2334 4 12.0001 4C9.76676 4 7.87509 4.775 6.32509 6.325C4.77509 7.875 4.00009 9.76667 4.00009 12C4.00009 14.2333 4.77509 16.125 6.32509 17.675C7.87509 19.225 9.76676 20 12.0001 20C14.2334 20 16.1251 19.225 17.6751 17.675C19.2251 16.125 20.0001 14.2333 20.0001 12C20.0001 11.7667 19.9876 11.5375 19.9626 11.3125C19.9376 11.0875 19.9084 10.8583 19.8751 10.625C20.2084 10.4917 20.5251 10.3208 20.8251 10.1125C21.1251 9.90417 21.4001 9.66667 21.6501 9.4C21.7668 9.81667 21.8543 10.2417 21.9126 10.675C21.9709 11.1083 22.0001 11.55 22.0001 12C22.0001 13.3833 21.7376 14.6833 21.2126 15.9C20.6876 17.1167 19.9751 18.175 19.0751 19.075C18.1751 19.975 17.1168 20.6875 15.9001 21.2125C14.6834 21.7375 13.3834 22 12.0001 22C10.6168 22 9.31676 21.7375 8.10009 21.2125C6.88343 20.6875 5.82509 19.975 4.92509 19.075C4.02509 18.175 3.31259 17.1167 2.78759 15.9C2.26259 14.6833 2.00009 13.3833 2.00009 12ZM18.0001 9C17.1668 9 16.4584 8.70833 15.8751 8.125C15.2918 7.54167 15.0001 6.83333 15.0001 6C15.0001 5.16667 15.2918 4.45833 15.8751 3.875C16.4584 3.29167 17.1668 3 18.0001 3C18.8334 3 19.5418 3.29167 20.1251 3.875C20.7084 4.45833 21.0001 5.16667 21.0001 6C21.0001 6.83333 20.7084 7.54167 20.1251 8.125C19.5418 8.70833 18.8334 9 18.0001 9Z"
                fill={selectedItem === "notifications" ? "var(--main-purple)" : "var(--main-white)"}
                opacity={selectedItem === "notifications" ? "1" : "0.5"} />
            </g>
          </svg>
        </div>

        {/* Feedback */}
        <ion-icon
          title="Feedback"
          name="chatbox-ellipses-outline"
          onClick={() => { navigate("/feedback"); handleItemClick("feedback"); }}
          style={{
            color: selectedItem === "feedback" ? "var(--main-purple)" : "var(--main-white)",
            opacity: selectedItem === "feedback" ? "1" : "0.75",
            fontSize: "1.4rem",
            cursor: "pointer",
          }}
        ></ion-icon>

        {/* Logout */}
        <ion-icon
          title="Logout"
          name="log-out-outline"
          onClick={handleLogout}
          style={{
            color: "var(--main-white)",
            opacity: "0.75",
            cursor: "pointer",
          }}
        ></ion-icon>
      </nav>

      {/* Logout confirmation modal */}
      {showLogoutConfirm && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            style={{
              backgroundColor: "#1e1e2e",
              borderRadius: 20,
              padding: "2rem",
              textAlign: "center",
              minWidth: 280,
              maxWidth: "90vw",
              border: "1px solid rgba(185,151,255,0.2)",
              boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <ion-icon name="log-out-outline" style={{ fontSize: "2.5rem", color: "var(--main-purple)", marginBottom: 12 }}></ion-icon>
            <h4 style={{ color: "#fff", marginBottom: 8 }}>Logout?</h4>
            <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: 20 }}>Are you sure you want to log out?</p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                style={{
                  backgroundColor: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.2)",
                  borderRadius: 20,
                  padding: "8px 24px",
                  cursor: "pointer",
                  fontSize: "0.95rem",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                style={{
                  backgroundColor: "#ff4444",
                  color: "#fff",
                  border: "none",
                  borderRadius: 20,
                  padding: "8px 24px",
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
